<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-title>Dashboard</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <AdminDashboard />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import AdminDashboard from "@/components/admin/AdminDashboard.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'adminDashboard',
    components: {
      AdminDashboard, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>
